module.exports = __webpack_public_path__ + "8fcc940bdd5c8ddb8df6c97219ff4370.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CN.svg
// module id = d6Ym
// module chunks = 0